import { html, render } from 'lit-html';
import * as brandStyles from 'url:../../brand.css';
import * as globalStyles from 'url:../../global.css';
import * as footerStyles from 'url:./style.css';
import * as instaIcon from 'url:../../assets/instagram.svg';
import * as ytIcon from 'url:../../assets/youtube.svg';

class CustomFooter extends HTMLElement {
  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  attributeChangedCallback() {
    this.render();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    const template = html`
      <link href="${brandStyles}" rel="stylesheet" />
      <link href="${footerStyles}" rel="stylesheet" />
      <link href="${globalStyles}" rel="stylesheet" />
      <footer class="footer">
        <div class="container">
          <p class="copyright">&copy; 2025 Dan’s Music Lessons. All rights reserved.</p>
          <div class="contact-lines">
            <p class="contact-item">
              Email:
              <a href="mailto:danieljsitar@gmail.com">danieljsitar@gmail.com</a>
            </p>
            <p class="contact-item">
              Phone:
              <a href="tel:+19783027411">(978) 302-7411</a>
            </p>
            <p class="contact-item legal-links">
              <strong>Legal:</strong>
              <a href="/privacy">Privacy Policy</a>
              <span aria-hidden="true"> / </span>
              <a href="/tos">Terms of Service</a>
            </p>
          </div>
          <div class="social">
            <a
              href="https://www.instagram.com/dansitar"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <img src="${instaIcon}" alt="Instagram" class="social-icon ig" />
            </a>
            <a
              href="https://www.youtube.com/@dansitar1"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <img src="${ytIcon}" alt="YouTube" class="social-icon yt" />
            </a>
          </div>
          <div class="design-by">
            Designed by
            <a
              class="ethnocentric-regular"
              href="https://brainedge.llc"
              target="_blank"
              >Brain Edge</a
            >
          </div>
        </div>
      </footer>
    `;

    render(template, this.shadow);
  }
}

customElements.define('custom-footer', CustomFooter);
